import { UserContext } from '@benefits/common-services';
import { AuthRoutes } from '@benefits/router-services/src/routes/auth';
import { DashboardRoutes } from '@benefits/router-services/src/routes/dashboard';
import { Button, Heading1, Text } from '@ifood/pomodoro-components';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';

import { useErrorEventDispatcher } from '../../services/useErrorDispatcher';
import { Image } from '../Image';
import { ButtonsWrapper, Container } from './NotFound404.styles';

const NotFound404 = () => {
  const route = useRouter();
  const dispatcher = useErrorEventDispatcher();

  const context = useContext(UserContext);
  const hasUser = !!context?.state?.user;

  useEffect(() => {
    dispatcher.sendEvent('ERROR_404_NOT_FOUND');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRedirectDashboard = () => {
    dispatcher.sendEvent('ERROR_404_NOT_FOUND_CLICK_HOME');
    route.push(DashboardRoutes.DASHBOARD);
  };

  const handleRedirectToLogin = () => {
    dispatcher.sendEvent('ERROR_404_NOT_FOUND_CLICK_LOGIN');
    route.push(AuthRoutes.LOGIN);
  };

  return (
    <Container>
      <Image
        alt="Ilustração de uma pessoa parecida com o meme do John Travolta em Pulp Fiction, segurando um papel verde e procurando por algo com um balão de fala amarelo com interrogação"
        height={200}
        src="/svgs/global_empty_G.svg"
        width={200}
      />

      <Heading1 m={0} textAlign="center" variant="large">
        Erro 404: não encontramos a página que você busca
      </Heading1>

      <Text>Aqui tem alguns links que podem te ajudar:</Text>

      <ButtonsWrapper>
        {hasUser ? (
          <Button size="medium" onClick={handleRedirectDashboard}>
            Ir para página inicial
          </Button>
        ) : (
          <Button size="medium" variant="secondary" onClick={handleRedirectToLogin}>
            Ir para a entrada
          </Button>
        )}
      </ButtonsWrapper>
    </Container>
  );
};

export { NotFound404 };
